import React from 'react';

const icons: Record<string, React.ReactNode> = {
  knowledge: (
    <>
      <path d="M12 5c-3-2-6-2-9-1v15c3-1 6-1 9 1 3-2 6-2 9-1V4c-3-1-6-1-9 1Zm0 0v15" />
      <path d="M6 8h3M6 12h3M15 8h3M15 12h3" />
    </>
  ),
  documents: (
    <>
      <path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8l-5-5Z" />
      <path d="M14 3v5h5M9 12h6M9 16h6" />
    </>
  ),
  meetings: (
    <>
      <path d="M20 11a7 7 0 0 1-7 7H9l-5 3v-6a7 7 0 0 1 5-12h4a7 7 0 0 1 7 8Z" />
      <path d="M8 8h8M8 12h5" />
    </>
  ),
  data: (
    <>
      <rect
        height="18"
        rx="2"
        width="18"
        x="3"
        y="3"
      />
      <path d="M3 9h18M3 15h18M9 9v12" />
    </>
  ),
  emails: (
    <>
      <rect
        height="14"
        rx="2"
        width="20"
        x="2"
        y="5"
      />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
  custom: (
    <>
      <path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 3V6a2 2 0 0 1 2-2Z" />
      <path d="M12 7v7M8.5 10.5h7" />
    </>
  ),
};

const ScenarioIcon: React.FC<{ kind: string }> = ({ kind }) => (
  <svg
    aria-hidden="true"
    className="scenario-icon"
    fill="none"
    height="20"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.6"
    viewBox="0 0 24 24"
    width="20"
  >
    {icons[kind]}
  </svg>
);

export default ScenarioIcon;
